import { render } from "./GraPes.vue?vue&type=template&id=68ec925f"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/GraPes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68ec925f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68ec925f', __exports__)) {
    api.reload('68ec925f', __exports__)
  }
  
  module.hot.accept("./GraPes.vue?vue&type=template&id=68ec925f", () => {
    api.rerender('68ec925f', render)
  })

}


export default __exports__